import { ArticleAccessLevelType, ArticleLanguageType } from '../../../models/article';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { zip, debounceTime, takeUntil, Subject } from 'rxjs';
import { extractAttributeFromTag } from 'src/app/common/function';
import { Article, ArticleFilter } from 'src/app/models/article';
import { ArticleService } from 'src/app/services/article.service';
import { LoaderService } from 'src/app/services/loader.service';
import { DatepickerInputComponent } from 'src/app/shared/components/datepicker-input/datepicker-input.component';
import { UserService } from '../../../services/user.service';
import { TranslationService } from '../../../services/translation.service';

@Component({
  selector: 'app-all-articles',
  templateUrl: './all-articles.component.html',
  styleUrls: ['./all-articles.component.scss'],
})
export class AllArticlesComponent implements OnInit, OnDestroy {
  // #region INPUT, OUTPUT, VIEWCHILD
  @ViewChild('fromDatePicker', { static: false })
  fromDatePicker: DatepickerInputComponent;
  @ViewChild('toDatePicker', { static: false })
  toDatePicker: DatepickerInputComponent;
  // #endregion
  model!: NgbDateStruct;
  modelTo!: NgbDateStruct;
  fromdropdownVisible = false;
  todropdownVisible = false;
  types: { id: number; name: string }[];
  peoples: { id: number; name: string }[];
  typeSelect: { id: number; name: string }[] = [];
  peopleSelect: { id: number; name: string }[] = [];
  isShowAllArticle = true;
  articleFilter: ArticleFilter = new ArticleFilter();
  articles: Article[] = [];
  pagesize = 6;
  totalPage = 0;
  currentPage = 1;
  totalRecord = 0;
  resetPagination() {
    this.pagesize = 6;
    this.totalPage = 0;
    this.currentPage = 1;
    this.totalRecord = 0;
  }
  delay: number = 500;
  searchOnGoing: boolean = false;
  articleCreationAllowed: boolean = true;
  language: ArticleLanguageType = ArticleLanguageType.English;
  private destroy$ = new Subject<void>();

  constructor(
    private articleService: ArticleService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private re: Router,
    private toastr: ToastrService,
    private userService: UserService,
    public translationService: TranslationService
  ) {
    this.language = this.translationService.language == 'id' ? ArticleLanguageType.Indonesian : ArticleLanguageType.English;
  }

  formGroup = new FormGroup({
    Search: new FormControl(''),
    fromDate: new FormControl(''),
    toDate: new FormControl('')
  });

  onPageChange(e: any) {
    this.currentPage = e;
    this.loadData();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (params["type"]) {
        if (params['type'] == 'my') {
          this.isShowAllArticle = false;
          this.getUserDetails();
        } else if (params['type'] == 'liked') {
          this.isShowAllArticle = true;
        } else {
          this.re.navigate(["/"]);
        }

        this.resetPagination();
        this.loadFiterData();
      }
    });

    // Subscribe to language change events
    this.translationService.changeLangEmitted$
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => {
        this.language = lang == 'id' ? ArticleLanguageType.Indonesian : ArticleLanguageType.English;
        this.loadFiterData();
      });

    this.formGroup.get('Search').valueChanges.pipe(debounceTime(this.delay)).subscribe(() => {
      if (
        (this.formGroup.get('Search').value?.trim() === "" && this.articleFilter?.searchText?.trim() !== "") ||
        (this.formGroup.get('Search').value?.trim() !== "" && this.articleFilter?.searchText?.trim() !== this.formGroup.get('Search').value?.trim())
      ) {
        if (this.searchOnGoing) {
          setTimeout(() => {
            this.applyFilter();
          }, 1000);
        } else {
          this.searchOnGoing = true;
          this.applyFilter();
        }
      }
    });
  }



  loadFiterData() {
    this.loaderService.setLoading(true);
    zip(
      this.articleService.getTopics(),
      this.articleService.getAuthors()
    ).subscribe(
      (response: any) => {
        if (response[0] && response[1]) {
          this.types = response[0].map((item) => ({
            id: item.id,
            name: item.name,
          }));
          this.peoples = response[1].map((items) => ({
            id: items.id,
            name: items.title,
          }));

          this.loadData();
        }
      },
      (err) => {
        this.loaderService.setLoading(false);
      }
    );
  }

  loadData() {
    this.loaderService.setLoading(true);
    this.articleFilter.showOnlyMyArticle = !this.isShowAllArticle;
    this.articleFilter.showOnlyMyLikedArticle = this.isShowAllArticle;
    this.articleFilter.pageSize = this.pagesize;
    this.articleFilter.pageNumber = this.currentPage;
    this.articleFilter.language = this.language;
    this.articleService.getArticles(this.articleFilter).subscribe(
      (res: any) => {
        this.totalRecord = res.total;
        this.totalPage = res.total / this.pagesize;
        if (res && res.records) {
          this.articles = res.records.map((item) => {
            let article = new Article();
            article.id = item.id;
            article.accessLevelName = item.accessLevelName;
            article.accessLevel = item.accessLevel;
            article.status = item.status;
            article.authorId = item.authorId;
            article.authorImageUrl = item.authorImageUrl;
            article.authorName = item.authorName;
            article.title = item.title?.replace(/<[^>]*>/g, '');
            article.description = item.description?.replace(/<[^>]*>/g, '').substring(0, 150);
            article.mainImage = item.mainImage;
            article.commentCount = item.commentCount;
            article.likeCount = item.likeCount;
            article.dislikeCount = item.dislikeCount;
            article.publishedOn = item.publishedOn;
            article.tags = item.tags;
            article.articleBlocks = item.articleBlocks;
            if (article.accessLevel == ArticleAccessLevelType.Public) {
              article.accessLevelStyle = 'theme-pink';
            } else if (article.accessLevel == ArticleAccessLevelType.Connections) {
              article.accessLevelStyle = 'theme-green';
            } else if (article.accessLevel = ArticleAccessLevelType.Followers) {
              article.accessLevelStyle = 'theme-yellow';
            }

            return article;
          });
        }
        this.searchOnGoing = false;
        this.loaderService.setLoading(false);
      },
      (err) => {
        this.searchOnGoing = false;
        this.loaderService.setLoading(false);
      }
    );
  }

  clearFilter() {
    this.formGroup.reset();
    this.typeSelect = [];
    this.peopleSelect = [];
    this.articleFilter = new ArticleFilter();
    this.loadData();
  }

  get isFiterApply() {
    return ((this.formGroup.get('fromDate').value && this.formGroup.get('toDate').value) ||
      this.typeSelect?.length || this.peopleSelect?.length) ? true : false;
  }

  applyFilter() {
    this.articleFilter.searchText = this.formGroup.get('Search').value;
    if (
      this.formGroup.get('fromDate').value != '' &&
      this.formGroup.get('fromDate').value != null
    ) {
      this.articleFilter.fromDate = this.formateDate(
        this.formGroup.get('fromDate').value
      );
    } else {
      this.articleFilter.fromDate = null;
    }
    if (
      this.formGroup.get('toDate').value != '' &&
      this.formGroup.get('toDate').value != null
    ) {
      this.articleFilter.toDate = this.formateDate(
        this.formGroup.get('toDate').value
      );
    } else {
      this.articleFilter.toDate = null;
    }

    this.articleFilter.category = [];
    if (this.typeSelect.length > 0) {
      this.articleFilter.category.push(
        ...this.typeSelect.map((item) => item.id)
      );
    }

    this.articleFilter.uploadedByUserId = [];
    if (this.peopleSelect.length > 0) {
      this.articleFilter.uploadedByUserId.push(
        ...this.peopleSelect.map((item) => item.id)
      );
    }

    this.loadData();
  }

  toggleDropdown(visible: boolean, datePicker: string) {
    if (datePicker == 'from') {
      this.fromdropdownVisible = visible;
    }
    if (datePicker == 'to') {
      this.todropdownVisible = visible;
    }
  }

  formateDate(dateRange: any) {
    const dateString = JSON.stringify(dateRange);
    const dateValue = JSON.parse(dateString);
    const dateObj =
      `{year: ${dateValue.year}, month: ${dateValue.month}, day: ${dateValue.day}}` as string;
    const parts = dateObj.split(/[\s{},:]+/);
    const selectedDate = new Date(
      parseInt(parts[2]),
      parseInt(parts[4]) - 1,
      parseInt(parts[6])
    );
    const date = new Date(
      Date.UTC(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        0,
        0,
        0
      )
    );
    return date;
  }

  articlePreview(articleId: number) {
    this.re.navigate([`article-preview/${!this.isShowAllArticle ? 1 : 0}/${articleId}`]);
  }

  getUserDetails = () => {
    this.userService
      .getById(`/api/tenants/myProfile`)
      .subscribe((response: any) => {
        if (!response.allowArticleCreation) {
          this.toastr.error("You do not have sufficient access to visit this page.");
          this.re.navigate(["/"]);
        }
        this.articleCreationAllowed = response && !response.isMembershipVendor && !response.allowArticleCreation ? false : true;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
